import { api } from 'services/api';
import { AUTH } from 'state/auth/type';

// fetch id from backend
export const toFetchTenant = async (): Promise<AUTH.IUser> => {
  // calling the backend API for getting the tenant Id
  const response = await api.get<AUTH.IUser>('/profile');
  return response.data;
};
